// extracted by mini-css-extract-plugin
export default {"loadingContainer":"lTJa5ZRm89BUGwp98EMkqA==","buttonGroup":"_5lcxPZw4Un4sINY+iR79Ag==","adminBox":"irfnUgCDCDo-LMoZWK7uVQ==","taxNotice":"Y7UnUxDAgBOWlHPtMBu1OA=="};